import { render, staticRenderFns } from "./m-header.vue?vue&type=template&id=b861570e&"
import script from "./m-header.vue?vue&type=script&lang=js&"
export * from "./m-header.vue?vue&type=script&lang=js&"
import style0 from "./m-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports